/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { UnprocessableEntityPayload } from '../types/api/UnprocessableEntityPayload';

export const unprocessibleEntityToObject = <Properties extends keyof any>(
  data: UnprocessableEntityPayload<Properties>,
): Partial<Record<Properties, string>> => {
  const result: Partial<Record<Properties, string>> = {};
  data.map(i => (result[i.property] = i.constraints[0] || ''));
  return result;
};
